import type { MutableRefObject } from 'react'
import { useState } from 'react'
import { useResizeObserver } from '@fs/zion-frontend-friends'

export default (ref: MutableRefObject<HTMLElement>): number => {
  const [buttonScale, setButtonScale] = useState(1.06)

  // Use dynamic scaling, so the huge buttons don't
  // get way too huge when hovered.
  useResizeObserver(ref, () => {
    const width = ref.current?.clientWidth || 100
    setButtonScale(1 + 5 / width)
  })

  return buttonScale
}
